import React, { useContext, useCallback } from 'react';
import { IViewCategoryContext, ViewCategoryContext } from '../viewCategoryState/viewCategoryContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalAssignCategoryToRestaurants } from 'components/ModalWindows/ModalAssignCategoryToRestaurants';

export const ModalWindows: React.FC = () => {
	const { changeTypeOfModalWindow, refetchData, categoryFullInfo, typeOfModalWindow } =
		useContext<IViewCategoryContext>(ViewCategoryContext);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleCloseModalWithRefetchData = useCallback(() => {
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, [refetchData, changeTypeOfModalWindow]);

	const handleCloseAssignRestaurantsModalWithError = useCallback(() => {
		changeTypeOfModalWindow('errorUpdatingCategory');
	}, [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'errorUpdatingCategory' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorUpdatingCategory"
				/>
			)}
			{typeOfModalWindow === 'assignRestaurants' && (
				<ModalAssignCategoryToRestaurants
					onCloseModal={handleCloseModalWithRefetchData}
					onFailureEvent={handleCloseModal}
					onShowError={handleCloseAssignRestaurantsModalWithError}
					categoryId={categoryFullInfo?.id || ''}
				/>
			)}
		</ModalWrapper>
	);
};
